import { Route, Routes } from "react-router-dom";
import EventDetails from "./event-details";
import ViewEvents from "./view-events";

const Events = () => (
    <Routes>
        <Route path="/:eventid/*" element={<EventDetails />} />
        <Route path="/" element={<ViewEvents />} />
    </Routes>
);

export default Events;
